import template from './queries.html';
import controller from './queries.controller';
import './queries.styl';

let queriesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default queriesComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/queries/queries.component.js